import { cn } from '@/lib/cn';

type Variant = 'ok' | 'running' | 'fail' | 'warn' | 'idle';

interface DotProps {
  variant?: Variant;
  pulse?: boolean;
  className?: string;
}

const VARIANT: Record<Variant, string> = {
  ok: 'bg-emerald',
  running: 'bg-violet',
  fail: 'bg-rose',
  warn: 'bg-amber',
  idle: 'bg-line-3',
};

export function Dot({ variant = 'ok', pulse, className }: DotProps) {
  return (
    <span
      className={cn(
        'inline-block h-1.5 w-1.5 rounded-full',
        VARIANT[variant],
        pulse && 'dot-live',
        className,
      )}
    />
  );
}
